import { guideSteps } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GuideSteps() {
  return (
    <section id="guide" className="bg-background-50">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-page">
          <SectionHeading
            index="05 / 下载指引"
            title="四步走通，从本页到可用入口不绕路"
            desc="不管是第一次来还是换新地址，按这四步操作，基本不用再回头找同一份入口。"
          />

          <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
            {guideSteps.map((step) => (
              <div
                key={step.step}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <span className="font-heading text-3xl font-bold text-primary-500">
                  {step.step}
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.summary}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col items-start gap-4 rounded-xl border border-primary-200 bg-primary-50 px-5 py-5 sm:flex-row sm:items-center sm:justify-between md:px-7">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-lightbulb-flash-line text-xl" />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  小提示：入口随时在动，先看更新条
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-700">
                  任何入口都以上方更新条的时间为准，日期最新的一条才代表当下同步的地址。
                </p>
              </div>
            </div>
            <a
              href="#entry"
              className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 text-sm text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-links-line" />
              回到入口索引
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}